import { SearchOutlined } from '@ant-design/icons';
import { useRouter } from 'next/router';
import React from 'react';
import { ConsultingSearchRoute } from 'services/routes';
import { StyledButton } from './style';

const ConsultingSearch: React.FC<{
  activeSkill: number | string;
  searchValue: string;
  setSearchValue: (status) => void;
}> = ({ activeSkill, searchValue, setSearchValue }) => {
  const router = useRouter();

  return (
    <form
      onSubmit={(e): void => {
        e.preventDefault(); // Prevent the default form submission
        router.push(ConsultingSearchRoute(searchValue, activeSkill), undefined, {
          shallow: true,
        });
      }}
      className="bg-white flex items-center rounded-full h-[56px]"
    >
      <div className="flex-1 pr-[24px] flex items-center">
        <SearchOutlined style={{ fontSize: 20, color: '#2b4660' }} />
        <input
          value={searchValue}
          onChange={(e): void => setSearchValue(e.target.value)}
          placeholder="نام، تخصص، ..."
          className="w-full h-[28px] mr-[4px]"
        />
      </div>

      <StyledButton
        type="submit"
        className="m-[4px] h-[48px] text-[14px] w-[80px] md:w-[140px] font-bold rounded-full text-white"
      >
        جستجو
      </StyledButton>
    </form>
  );
};

export default ConsultingSearch;
